document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('special_content')) {
        const special_content_form = document.querySelector("#special_content .form");
        const special_content_fields = special_content_form.querySelectorAll(".field");
        const special_content_general = document.querySelector("#special_content .form--button");
        const special_content_success = document.querySelector("#special_content .success");
        const special_content_button = document.querySelector("#special_content .form--button button");
        const special_content_loading = document.querySelector("#special_content .loading");
        const special_content_form_id = special_content_form.getAttribute("data-form-id");

        special_content_button.addEventListener("click", function (e) {
            e.preventDefault();
            let form_is_valid = true;

            special_content_fields.forEach(function (field) {

                if (field.type === "checkbox" && !field.checked) {
                    form_is_valid = false;
                    field.parentNode.classList.add('form--error');
                } else if (!field.validity.valid || field.value === '') {
                    form_is_valid = false;
                    field.parentNode.classList.add('form--error');
                } else {
                    field.parentNode.classList.remove('form--error');
                }
            });

            if (form_is_valid) {
                special_content_general.classList.remove('form--error');
                special_content_loading.style.display = "flex";
                special_content_form.style.opacity = '0.3';

                let data = {
                    "fields": []
                };

                special_content_fields.forEach(function (field) {
                    const field_name = field.getAttribute("name");
                    const field_value = field.type === "checkbox" ? field.checked : field.value;

                    data.fields.push({
                        "name": field_name,
                        "value": field_value
                    });
                });

                var xhr = new XMLHttpRequest();
                xhr.open("POST", "https://api.hsforms.com/submissions/v3/integration/submit/" + hubspot_id + "/" + special_content_form_id);
                xhr.setRequestHeader("Content-Type", "application/json");

                xhr.onload = function () {
                    if (xhr.status === 200 || xhr.status === 204) {
                        special_content_success.style.display = "block";
                        special_content_form.style.display = "none";
                        special_content_loading.style.display = "none";
                    } else {
                        special_content_general.classList.add('form--error');
                        special_content_loading.style.display = "none";
                        special_content_form.style.opacity = '100';
                    }
                };

                xhr.send(JSON.stringify(data));
            }
        });

        special_content_fields.forEach(function (field) {
            field.addEventListener("input", function () {
                if (field.validity.valid || field.value === '') {
                    field.parentNode.classList.remove('form--error');
                }
            });
        });
    }
});